import './App.css';
import Router from "wrappers/router"

export default function App() {
  return <Router />
}